<template>
	<div style="padding-top: 24px">
		<div style="margin-bottom: 24px">
			<a-form layout="inline" :form="searchForm">
				<a-row type="flex" justify="space-between">
					<a-col>
						<a-form-item label="客户名称">
							<a-input allowClear v-decorator="['organizationName']" placeholder="输入客户名称" />
						</a-form-item>
						<a-form-item label="授权设备">
							<a-select allowClear style="min-width: 200px" placeholder="请选择授权设备" v-decorator="['deviceId']">
								<a-select-option v-for="item in modeList" :value="item.id" :key="item.id">{{ item.name}}</a-select-option>
								<!-- <a-select-option value="0">2</a-select-option> -->
							</a-select>
						</a-form-item>
						<a-form-item>
							<a-space :size="8">
								<a-button type="primary" @click="getTableList(1)"><i class="el-icon-search"></i>
									查询</a-button>
								<a-button type="default" @click="getTableList(2)"><i class="el-icon-refresh"></i> 重置</a-button>
							</a-space>
						</a-form-item>
					</a-col>
					<a-col>
						<a-form-item>
							<a-space :size="8">
								<a-button type="primary" @click="openModal()"><i class="el-icon-plus"></i>
									新增授权</a-button>
							</a-space>
						</a-form-item>
					</a-col>
				</a-row>
			</a-form>
		</div>

		<div class="tableInit">
			<el-table :data="dataSource" border style="width: 100%">
				<el-table-column prop="organizationName" label="客户名称" align="center">
				</el-table-column>
				<el-table-column prop="deviceName" label="授权设备" align="center">
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="250" align="center">
					<template slot-scope="scope">
						<el-button @click="openModal(scope.row)" icon="el-icon-edit" type="primary" size="small" plain>编辑</el-button>
						<el-button type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)" size="small" plain>删除</el-button>
					</template>
				</el-table-column>
			</el-table>

			<pagination :total="pagination.total" :page.sync="pagination.current" :limit.sync="pagination.pageSize"
				@pagination="getPageList" />

		</div>

		<a-modal :title="modalTitle" :visible="visible" @ok="modalSubmit" @cancel="cancelModal" cancelText="取消" okText="确定"
			destroyOnClose>
			<a-form :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" :form="modalForm">
				<a-form-item label="客户名称" v-if="modalType == 'add'">
					<a-select v-decorator="[
				'organizationId',
				{ rules: [{ required: true, message: '请选择客户！' }] },
			]" placeholder="请选择客户" @change="handleChange">
						<a-select-option v-for="item in modalSelectOptionsList" :value="item.id" :key="item.id">{{
							item.name
							}}</a-select-option>
					</a-select>
				</a-form-item>
				<a-form-item label="接入设备">
					<a-checkbox-group v-decorator="[
				'deviceId',
				{ rules: [{ required: true, message: '请选择接入设备！' }] },
			]" style="width: 100%">
						<a-row type="flex" align="middle">
							<a-col :span="12" v-for="item in modeList" :key="item.id">
								<a-checkbox :value="item.id"><span style="color: #fff">{{ item.name
										}}</span></a-checkbox>
							</a-col>
						</a-row>
					</a-checkbox-group>
				</a-form-item>
			</a-form>
		</a-modal>
	</div>
</template>
<script>
import * as API_Ques from "@/api/dataAccess/accessApi";
export default {
	data() {
		return {
			formItemLayout: {
				labelCol: {
					span: 4,
				},
				wrapperCol: {
					span: 20,
				},
			},
			columns: [{
				title: "序号",
				dataIndex: "num",
				key: "num",
				align: "center",
				width: 80,
				customRender: (text, record, index) => `${index + 1}`,
			},
			{
				title: "客户名称",
				dataIndex: "organizationName",
				key: "organizationName",
				align: "center",
			},
			{
				title: "授权设备",
				dataIndex: "deviceName",
				key: "deviceName",
				align: "center",
				slots: {
					customRender: "deviceName",
					action: "deviceName",
				},
			},
			{
				title: "操作",
				dataIndex: "action",
				key: "action",
				width: 280,
				align: "center",
				scopedSlots: {
					customRender: "action",
				},
			},
			],
			form: {},
			pagination: {
				total: 0,
				current: 1,
				pageSize: 10,
			},
			dataSource: [],
			modalTitle: null,
			visible: false,
			modalForm: this.$form.createForm(this, {
				userName: "dynamic_rule",
				shebei: "dynamic_rule",
			}),
			searchForm: this.$form.createForm(this, {}),
			modalSelectOptionsList: [],
			modalCheckboxList: [],
			modeList: [],
			modalType: "add",
			selectRecord: null,
			organizationId: "",
		};
	},
	created() {
		this.init();
	},
	methods: {
		// 获取设备下拉框数据
		getDeviceListFun() {
			API_Ques.getDeviceList()
				.then((res) => {
					console.log(res);
					const {
						code,
						data,
						msg
					} = res;
					if (code == 200) {
						this.modeList = data;
						return;
					}
					this.$message.error(msg || "接口异常，请联系管理员！");
				})
				.catch((err) => {
					this.$message.error(err || "接口异常，请联系管理员！");
				});
		},
		// 弹窗客户列表
		getOrganizationFindAllFun() {
			API_Ques.organizationFindAll()
				.then((res) => {
					const {
						code,
						data,
						msg
					} = res;
					if (code == 200) {
						this.modalSelectOptionsList = data;
						return;
					}
					this.$message.error(msg || "接口异常，请联系管理员！");
				})
				.catch((err) => {
					this.$message.error(err || "接口异常，请联系管理员！");
				});
		},
		getPageList() {
			// console.log(this.pagination);
			this.getTableList()
		},
		// 获取列表数据
		getTableList(type) {
			this.dataSource = [];
			if (type) {
				this.pagination.current = 1;
			}
			if (type == 2) {
				// console.log(1111111111111111)
				this.searchForm.resetFields();
			}
			const {
				current,
				pageSize
			} = this.pagination;
			// console.log(this.pagination);
			const searchFormData = this.searchForm.getFieldsValue();
			const body = {
				...searchFormData,
				...{
					pageSize: pageSize,
					pageNum: current,
				},
			};
			// console.log(body);
			API_Ques.getUserList(body).then((res) => {
				const {
					code,
					data,
					msg
				} = res;
				if (code == 0 || code == 200) {
					this.dataSource = data.list;
					this.pagination.total = data.total * 1;
					return false;
				}
				this.$message.error(msg || "接口异常，请联系管理员");
			});
		},
		// 删除当前条数据
		handleDelete(row) {
			this.$confirm(`是否确定删除？`, "操作确认", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					const {
						organizationId
					} = row;
					const body = {
						organizationId
					};
					API_Ques.delDeviceJoin(body).then((res) => {
						const {
							code,
							msg
						} = res;
						if (code == 0 || code == 200) {
							this.getTableList(1);
							return false;
						}
						this.$message.error(msg || "接口异常，请联系管理员");
					});
				})
		},
		// 下载
		downloadFun(row) {
			console.log(row);
		},
		// 页码变动
		handleTableChange(paginationData) {
			const {
				pageSize,
				current
			} = paginationData;
			this.pagination.pageSize = pageSize;
			this.pagination.current = current;
			this.getTableList();
		},
		openModal(record) {
			this.modalType = record ? "edit" : "add";
			this.selectRecord = record;
			if (record) {
				const { organizationId } = record;
				this.getEditFind(organizationId);
			}
			this.modalTitle = record ? `【${record.organizationName}】 编辑` : '授权客户'
			this.visible = true;
		},
		cancelModal() {
			this.visible = false;
			setTimeout(() => {
				this.modalType = "add";
				this.selectRecord = null;
				this.modalFormData = {};
			}, 1000);
		},
		handleChange(e) {
			console.log(e);
			this.getEditFind(e);
		},
		modalSubmit() {
			this.modalForm.validateFieldsAndScroll((errors, values) => {
				if (!errors) {
					// 接口调用，成功后关闭弹窗，初始化所有数据
					const {
						deviceId,
						organizationId
					} = values;
					const body = [];
					deviceId.forEach((item) => {
						body.push({
							organizationId: this.modalType == "add" ? organizationId : this
								.organizationId,
							deviceId: item,
						});
					});
					if (this.modalType == "add") {
						this.addDeviceJoinFun(body);
					} else {
						this.editDeviceJoinFun(body);
					}
				}
			});
		},
		addDeviceJoinFun(body) {
			API_Ques.addDeviceJoin(body).then((res) => {
				const {
					code,
					msg
				} = res;
				if (code == 0 || code == 200) {
					this.cancelModal();
					this.getTableList(1);
					return false;
				}
				this.$message.error(msg || "接口异常，请联系管理员");
			});
		},
		editDeviceJoinFun(body) {
			API_Ques.editDeviceJoin(body).then((res) => {
				const {
					code,
					msg
				} = res;
				if (code == 0 || code == 200) {
					this.cancelModal();
					this.getTableList(1);
					return false;
				}
				this.$message.error(msg || "接口异常，请联系管理员");
			});
		},
		// 获取详情
		getEditFind(organizationId) {
			API_Ques.editFind({
				organizationId
			}).then((res) => {
				console.log(res)
				const { code, msg, data } = res;
				if (code == 0 || code == 200) {
					const deviceId = data.map((item) => item.id);
					console.log(deviceId, 'deviceId');
					this.organizationId = organizationId;
					this.$nextTick(() => {
						this.modalForm.setFieldsValue({
							deviceId,
						});
					})
					return false;
				}
				this.$message.error(msg || "接口异常，请联系管理员");
			});
		},
		init() {
			this.pagination.current = 1;
			this.getDeviceListFun();
			this.getOrganizationFindAllFun();
			this.getTableList(1);
		},
	}
}
</script>
<style scoped>
.ant-form-inline .ant-form-item-with-help {
	margin-bottom: 0 !important;
}
</style>